import React from 'react';
import inflection from 'inflection';
import { Navigate, useParams } from 'react-router-dom';

import styles from 'buyside/components/presentation/RankingsIndexPage/RankingsIndexStyles';

import CurrentUserRanks from 'buyside/components/container/RankingsIndex/CurrentUserRanksContainer';
import CurrentUserRankHistoryModal from 'buyside/components/presentation/RankingsIndexPage/currentUserRankInfo/CurrentUserRankHistoryModal';
import IdeaSubmitButton from 'buyside/components/container/RankingsIndex/SubmitResearchButtonContainer';
import IndexPage, { LeftSidebar, IndexArea } from '../IndexPage/IndexPage';
import NextRankingPublishDate from 'buyside/components/container/RankingsIndex/NextRankingPublishDateContainer';
import RankingsIndexArea from 'buyside/components/container/RankingsIndex/RankingsIndexAreaContainer';
import RankingsMethodologyModal from 'buyside/components/presentation/RankingsIndexPage/RankingsMethodologyModal';
import RankingsSidebar from 'buyside/components/presentation/RankingsIndexPage/RankingsSidebar';
import { BREAKPOINTS, useIsMobile } from 'buyside/util/hooks/useIsMobile';

const { rankingCategories } = require('buyside/util/constantsFromRails.json');

const RankingsIndexPage = ({ isPublic = false }) => {
  const { category } = useParams();

  const isMobile = useIsMobile(BREAKPOINTS.LARGE);

  if (!rankingCategories.includes(category)) return <Navigate to="/general" />;

  const titleCategory =
    category === 'general' ? inflection.titleize('All-Time') : inflection.titleize(category);

  return (
    <IndexPage>
      {!isMobile && (
        <LeftSidebar>
          <NextRankingPublishDate />
          <RankingsSidebar category={category} />
        </LeftSidebar>
      )}
      <IndexArea>
        {isMobile && <NextRankingPublishDate />}
        <h1 className={styles.indexTitle}>
          <span>Rankings - {titleCategory}</span> {!isPublic && <IdeaSubmitButton />}
        </h1>
        {!isPublic && (
          <>
            <CurrentUserRanks category={category} />
            <CurrentUserRankHistoryModal />
          </>
        )}
        <RankingsMethodologyModal />
        <RankingsIndexArea category={category} isPublic={isPublic} />
      </IndexArea>
    </IndexPage>
  );
};

export default RankingsIndexPage;
